import { inject, Injectable } from '@angular/core';
import { LoggingService } from '@lib-ui/lib/services/logging.service';
import { AuthenticationService } from '@lib-ui/lib/services/authentication.service';

import { protectedResources } from '../../../auth-config';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StartupService {
  private readonly loggingService = inject(LoggingService);
  private readonly authenticationService = inject(AuthenticationService);

  public load(): void {
    try {
      this.authenticationService.init(protectedResources, environment);
    } catch (error) {
      this.loggingService.logError('Failed to load startup data.', error);
    }
  }
}
